import React, { useState } from 'react';
import VehicleCard from '../VehicleCard';
import { VehiclePaymentModal } from './VehiclePaymentModal';
import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface PaymentOption {
  term: number;
  monthly_payment: number;
  apr: number;
  down_payment: number;
}

interface VehicleData {
  Main_Picture_URL?: string;
  Year?: number | string;
  Make?: string;
  Model?: string;
  Trim?: string;
  "Exterior Color"?: string;
  Price?: number;
  Mileage?: number;
  VDP_URL?: string;
  Stock_Number?: string;
  Vehicle_Description_Summary?: string;
  Features?: string[];
  CARFAX_URL?: string;
  VIN?: string;
  LowestPayment?: string;
  LowestPaymentTerms?: string;
  Payment_Data?: {
    payments?: PaymentOption[];
  };
  "vehicle location"?: {
    name?: string;
    phone?: string;
    location?: {
      city?: string;
      province?: string;
      postalCode?: string;
    };
  };
}

interface VehicleMessageProps {
  vehicle: VehicleData;
}

const VehicleMessage: React.FC<VehicleMessageProps> = ({ vehicle }) => {
  const [showPayments, setShowPayments] = useState(false);
  const { language, t } = useLanguage();
  const hasPayments = vehicle.Payment_Data?.payments && vehicle.Payment_Data.payments.length > 0;

  const getLocalizedVdpUrl = (url: string | undefined): string | undefined => {
    if (!url) return undefined;
    
    if (language === 'fr') {
      return url
        .replace('/used/', '/occasion/')
        .replace('/new/inventory/', '/neufs/inventaire/');
    }
    
    return url;
  };

  const handleMoreClick = () => {
    const vdpUrl = getLocalizedVdpUrl(vehicle.VDP_URL);
    if (vdpUrl) {
      window.open(vdpUrl, '_blank');
    }
  };

  return (
    <>
      <VehicleCard vehicle={vehicle} />
      <div className="mt-2 flex gap-2">
        {vehicle.VDP_URL && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleMoreClick}
          >
            <Eye className="w-4 h-4 mr-1" />
            {t('vehicle.more')}
          </Button>
        )}
        {hasPayments && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowPayments(true)}
          >
            View Payment Options
          </Button>
        )}
      </div>
      <VehiclePaymentModal
        open={showPayments}
        onOpenChange={setShowPayments}
        vehicleInfo={{
          year: vehicle.Year,
          make: vehicle.Make,
          model: vehicle.Model,
          trim: vehicle.Trim,
        }}
        payments={vehicle.Payment_Data?.payments}
      />
    </>
  );
};

export default VehicleMessage;
